module.exports = __webpack_public_path__ + "img/12.a29e01bb.jpg";